export const INSTITUTE_PAYMENT_API_ROUTES = {
    INSTITUTE_PAYMENT_CHECK: '/institute/institutepaymentcheck',
    CREATE_INSTITUTE_PAYMENT_ORDER: '/institute/createOrder',
    SUBSCRIBE_INSTITUTE_PLAN: '/institute/subscribeInstitutePlan',
    INSTITUTE_TOPUP_CHECK: '/institute/institutetopupcheck',
    INSTITUTE_SUBSCRIPTION_TOPUP: '/institute/institutesubscriptiontopup',
}